import { useState, useRef } from "react";
import { Api } from "../../Helpers/axios/axios";
import './FileUpload.css';

export const FileUpload = (props: any) => {
    const [Image, setImage] = useState<any>();
    const [isUploading, setIsUploading] = useState(false);
    const fileInputRef = useRef<HTMLInputElement>(null);

    const Upload = (event: React.ChangeEvent<HTMLInputElement>) => {
        let formData = new FormData();

        if (event.target.files && event.target.files.length > 0) {
            setIsUploading(true);
            formData.append("file", event.target.files[0])
            Api.upload(formData).then((data: any) => {
                // Handle different response structures:
                // 1. If errorCheck wasn't used: data.data.url
                // 2. If errorCheck was used: data.url
                // 3. Fallback to path just in case
                const imageUrl = data?.data?.url || data?.url || data?.path;
                setImage(imageUrl);
                props.onChange(props.fieldKey, imageUrl);
            }).catch((error: any) => {
               alert(error)
            }).finally(() => {
                setIsUploading(false);
            });
        }
        else {
            alert("The picture was corrupted");
        }
    };

    const triggerFileSelect = () => {
        fileInputRef.current?.click();
    };

    return (
        <div className="modern-file-upload">
            <div
                className="upload-drop-zone"
                onClick={triggerFileSelect}
            >
                <input
                    type="file"
                    ref={fileInputRef}
                    onChange={Upload}
                    className="hidden-file-input"
                />

                {isUploading ? (
                    <div className="upload-placeholder">
                        <div className="spinner"></div>
                        <p>Uploading...</p>
                    </div>
                ) : (props.value || Image) ? (
                    <div className="image-preview-container">
                        <img className="uploaded-image-preview" src={props.value || Image} alt="Uploaded" />
                        <div className="image-overlay">
                            <span>Change File</span>
                        </div>
                    </div>
                ) : (
                    <div className="upload-placeholder">
                        <svg className="upload-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                        </svg>
                        <p>Click to upload a file</p>
                        <span className="upload-hint">Upload any required file or image</span>
                    </div>
                )}
            </div>
        </div>
    );
}